/** @format */
import React, { useState } from 'react'
import localize from '../../../../../../Global/Localize'
import SimpleTable from '../../../../../../Components/Tables/SimpleTable'
import Checkbox from '../../../../../../Components/Checkbox/Checkbox'
import { postData } from '../../../../../../Helpers/webApi'
import Swal from 'sweetalert2'
import { showNotification } from '../../../../../../Helpers/Notification/ShowNotification'
import {
  formatCurrency,
  formatDate,
} from '../../../../../../Helpers/formatters'
import { MaskNumber } from '../../../../../../Components/InputMasks/MaskNumber'
import Loader from '../../../../../../Components/Loaders/Loader'

const GoodsReceivedNoteEntriesItems = ({
  edit,
  unpostedEntries,
  handleRemove,
  mode,
  entries,
  onSelectItem,
  loadEntries,
  totalCost,
}) => {
  const [selectedEntries, setSelectedEntries] = useState([])
  const [toggleSelection, setToggleSelection] = useState(false)
  const [isBusy, setIsBusy] = useState(false)

  const onCheckEntries = checkStatus => {
    if (checkStatus) {
      setToggleSelection(checkStatus)
      setSelectedEntries([])
      setSelectedEntries([...entries])
    } else {
      setSelectedEntries([])
      setToggleSelection(checkStatus)
    }
  }

  const removeEntries = async () => {
    if (selectedEntries.length === 0) {
      Swal.fire({
        icon: 'info',
        text: 'Select Atleast One Entry',
        title: 'Ooops!',
        showCloseButton: true,
      })
      return
    }
    setIsBusy(true)
    const { success } = await postData(
      '/GoodsReceivedNote/remove-goods-received-note-item',
      selectedEntries,
      false
    )
    if (success) {
      showNotification('Goods Received Note', 'success')
      loadEntries()
      setIsBusy(false)
    }
    setIsBusy(false)
  }

  const columns = [
    {
      label: localize('select') + '?',
      template: r => (
        <Checkbox
          checked={selectedEntries.find(x => x.id === r.id)}
          onCheck={c => {
            if (c) {
              setSelectedEntries([...selectedEntries, r])
              onSelectItem([...selectedEntries, r])
            } else {
              setSelectedEntries(selectedEntries.filter(s => s.id !== r.id))
              onSelectItem(selectedEntries.filter(s => s.id !== r.id))
            }
          }}
        />
      ),
    },
    {
      label: localize('itemType'),
      template: r => <>{r.itemRegisterItemTypeDescription}</>,
    },
    {
      label: localize('item'),
      template: r => <>{r.itemRegisterDescription}</>,
    },
    {
      label: localize('inventoryCategory'),
      template: r => <>{r.itemRegisterInventoryCategoryDescription}</>,
    },
    {
      label: localize('assetType'),
      template: r => <>{r.itemRegisterAssetTypeDescription}</>,
    },
    {
      label: localize('unitOfMeasure'),
      template: r => <>{r.itemRegisterInventoryUnitOfMeasureDescription}</>,
    },
    {
      label: localize('quantity'),
      template: r => <>{r.quantity}</>,
    },
    {
      label: localize('unitCost'),
      template: r => <>{formatCurrency(r.unitCost)}</>,
    },
    {
      label: localize('totalCost'),
      template: r => <>{formatCurrency(r.totalCost)}</>,
    },
    {
      label: localize('createdBy'),
      template: r => r.createdBy,
    },
    {
      label: localize('createdDate'),
      template: r => formatDate(r.createdDate),
    },
  ]
  return (
    <div>
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <SimpleTable
            columns={edit ? columns : columns.slice(1, -1)}
            data={mode === 'add' ? unpostedEntries : entries}
            contextMenu={
              mode !== 'add'
                ? null
                : r => (
                    <>
                      <div
                        onClick={() => {
                          handleRemove(r)
                        }}
                        className="ctxt-menu-item"
                      >
                        <i className="uil uil-trash text-danger"></i>
                        {localize('remove')}
                      </div>
                    </>
                  )
            }
          />
          {mode === 'view' && (
            <div className="row  mb-2">
              <div className="col-md-9"></div>
              <div className="col-md-3 d-flex align-items-center justify-content-end">
                <label className="col-md-2 text-capitalize me-2">
                  {localize('totalCost')}
                </label>
                <MaskNumber
                  className="form-control me-3 ms-3"
                  defaultMaskValue={totalCost}
                />
              </div>
            </div>
          )}

          {mode === 'edit' && (
            <>
              <div className="row mb-3 g-3 mt-2">
                <div className="col-md-6">
                  <div className="d-flex align-items-center mb-2">
                    <Checkbox
                      id="toggle-selection"
                      checked={toggleSelection}
                      onCheck={v => {
                        onCheckEntries(v)
                      }}
                    />
                    <label
                      htmlFor="toggle-selection"
                      className="text-capitalize ms-2"
                    >
                      {localize('toggleSelection')}
                    </label>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="d-flex justify-content-end align-items-end">
                    <button
                      onClick={removeEntries}
                      className="btn btn-success text-uppercase ms-3 px-4"
                    >
                      {localize('remove')}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  )
}

export default GoodsReceivedNoteEntriesItems
